export default __webpack_public_path__ + "static/media/hotChipBalloons.383d969e.png";